import React, { memo } from 'react';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarIcon from '@material-ui/icons/Star';
import Tooltip from '@material-ui/core/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
  star: {
    fontSize: '1rem',
    cursor: 'pointer',
  },
}));

const AddRemoveIcon = ({ data }) => {
  const classes = useStyles();

  return data.ticker && data.companyId ? (
    <Tooltip arrow title={data.isTickerActive ? 'Remove from Watchlist' : 'Add to Watchlist'}>
      {data.isTickerActive ? <StarIcon className={classes.star} /> : <StarBorderIcon className={classes.star} />}
    </Tooltip>
  ) : null;
};

export default memo(AddRemoveIcon);
